export default __webpack_public_path__ + "static/media/portrait12.4a936a08.jpeg";